export interface PSU {
  id: string;
  name: string;
  wattage: number;
  efficiency: string;
  modular: 'full' | 'semi' | 'non';
  price: number;
}

export interface PCCase {
  id: string;
  name: string;
  formFactor: 'full-tower' | 'mid-tower' | 'mini-tower' | 'sff';
  maxGPULength: number; // in mm
  maxGPUSlots: number;
  price: number;
}

export interface Motherboard {
  id: string;
  name: string;
  formFactor: 'ATX' | 'Micro-ATX' | 'Mini-ITX' | 'E-ATX';
  socket: string;
  pcieSlots: number;
  pcieVersion: string;
  price: number;
}

export const psus: PSU[] = [
  { id: 'corsair-rm1000x', name: 'Corsair RM1000x', wattage: 1000, efficiency: '80+ Gold', modular: 'full', price: 189 },
  { id: 'evga-supernova-1000', name: 'EVGA SuperNOVA 1000 G7', wattage: 1000, efficiency: '80+ Gold', modular: 'full', price: 179 },
  { id: 'seasonic-focus-850', name: 'Seasonic Focus GX-850', wattage: 850, efficiency: '80+ Gold', modular: 'full', price: 139 },
  { id: 'corsair-rm850x', name: 'Corsair RM850x', wattage: 850, efficiency: '80+ Gold', modular: 'full', price: 149 },
  { id: 'evga-supernova-750', name: 'EVGA SuperNOVA 750 G6', wattage: 750, efficiency: '80+ Gold', modular: 'full', price: 109 },
  { id: 'corsair-rm750', name: 'Corsair RM750', wattage: 750, efficiency: '80+ Gold', modular: 'full', price: 119 },
  { id: 'seasonic-focus-650', name: 'Seasonic Focus GX-650', wattage: 650, efficiency: '80+ Gold', modular: 'full', price: 99 },
  { id: 'corsair-cv650', name: 'Corsair CV650', wattage: 650, efficiency: '80+ Bronze', modular: 'non', price: 69 },
  { id: 'evga-500w', name: 'EVGA 500 W1', wattage: 500, efficiency: '80+ White', modular: 'non', price: 44 },
];

export const cases: PCCase[] = [
  { id: 'lian-li-o11', name: 'Lian Li O11 Dynamic EVO', formFactor: 'mid-tower', maxGPULength: 420, maxGPUSlots: 3, price: 169 },
  { id: 'corsair-5000d', name: 'Corsair 5000D Airflow', formFactor: 'mid-tower', maxGPULength: 400, maxGPUSlots: 3, price: 174 },
  { id: 'nzxt-h7', name: 'NZXT H7 Flow', formFactor: 'mid-tower', maxGPULength: 400, maxGPUSlots: 3, price: 129 },
  { id: 'fractal-torrent', name: 'Fractal Design Torrent', formFactor: 'full-tower', maxGPULength: 461, maxGPUSlots: 4, price: 239 },
  { id: 'phanteks-g500a', name: 'Phanteks Eclipse G500A', formFactor: 'mid-tower', maxGPULength: 435, maxGPUSlots: 3, price: 109 },
  { id: 'coolermaster-nr200p', name: 'Cooler Master NR200P', formFactor: 'sff', maxGPULength: 330, maxGPUSlots: 3, price: 119 },
  { id: 'nzxt-h510', name: 'NZXT H510', formFactor: 'mid-tower', maxGPULength: 381, maxGPUSlots: 2, price: 79 },
  { id: 'meshify-c', name: 'Fractal Design Meshify C', formFactor: 'mid-tower', maxGPULength: 315, maxGPUSlots: 2, price: 104 },
  { id: 'dan-a4', name: 'DAN A4-SFX', formFactor: 'sff', maxGPULength: 295, maxGPUSlots: 2, price: 199 },
];

export const motherboards: Motherboard[] = [
  { id: 'asus-rog-z790', name: 'ASUS ROG Maximus Z790 Hero', formFactor: 'ATX', socket: 'LGA1700', pcieSlots: 3, pcieVersion: '5.0', price: 629 },
  { id: 'msi-meg-z790', name: 'MSI MEG Z790 ACE', formFactor: 'ATX', socket: 'LGA1700', pcieSlots: 3, pcieVersion: '5.0', price: 599 },
  { id: 'gigabyte-z790-aorus', name: 'Gigabyte Z790 AORUS Master', formFactor: 'ATX', socket: 'LGA1700', pcieSlots: 3, pcieVersion: '5.0', price: 499 },
  { id: 'asus-rog-x670e', name: 'ASUS ROG Crosshair X670E Hero', formFactor: 'ATX', socket: 'AM5', pcieSlots: 3, pcieVersion: '5.0', price: 699 },
  { id: 'msi-meg-x670e', name: 'MSI MEG X670E ACE', formFactor: 'ATX', socket: 'AM5', pcieSlots: 3, pcieVersion: '5.0', price: 649 },
  { id: 'gigabyte-b650-aorus', name: 'Gigabyte B650 AORUS Elite AX', formFactor: 'ATX', socket: 'AM5', pcieSlots: 2, pcieVersion: '4.0', price: 229 },
  { id: 'asus-b650m', name: 'ASUS TUF Gaming B650M-Plus', formFactor: 'Micro-ATX', socket: 'AM5', pcieSlots: 2, pcieVersion: '4.0', price: 189 },
  { id: 'msi-b550-itx', name: 'MSI MPG B550I Gaming Edge', formFactor: 'Mini-ITX', socket: 'AM4', pcieSlots: 1, pcieVersion: '4.0', price: 199 },
  { id: 'asrock-b660m', name: 'ASRock B660M Pro RS', formFactor: 'Micro-ATX', socket: 'LGA1700', pcieSlots: 2, pcieVersion: '4.0', price: 109 },
];

// GPU physical specifications (length in mm, slots, recommended PSU)
export interface GPUPhysicalSpecs {
  gpuId: string;
  length: number;
  slots: number;
  recommendedPSU: number;
  connectors: string;
}

export const gpuPhysicalSpecs: Record<string, GPUPhysicalSpecs> = {
  'rtx-5090': { gpuId: 'rtx-5090', length: 336, slots: 4, recommendedPSU: 1000, connectors: '1x 16-pin' },
  'rtx-4090': { gpuId: 'rtx-4090', length: 336, slots: 4, recommendedPSU: 850, connectors: '1x 16-pin' },
  'rtx-5080': { gpuId: 'rtx-5080', length: 304, slots: 3, recommendedPSU: 750, connectors: '1x 16-pin' },
  'rtx-4080-super': { gpuId: 'rtx-4080-super', length: 304, slots: 3, recommendedPSU: 750, connectors: '1x 16-pin' },
  'rtx-5070-ti': { gpuId: 'rtx-5070-ti', length: 285, slots: 2.5, recommendedPSU: 700, connectors: '1x 16-pin' },
  'rtx-4080': { gpuId: 'rtx-4080', length: 304, slots: 3, recommendedPSU: 750, connectors: '1x 16-pin' },
  'rtx-4070-ti-super': { gpuId: 'rtx-4070-ti-super', length: 285, slots: 2.5, recommendedPSU: 700, connectors: '1x 16-pin' },
  'rtx-5070': { gpuId: 'rtx-5070', length: 267, slots: 2, recommendedPSU: 650, connectors: '1x 8-pin' },
  'rtx-4070-ti': { gpuId: 'rtx-4070-ti', length: 285, slots: 2.5, recommendedPSU: 700, connectors: '1x 16-pin' },
  'rtx-4070-super': { gpuId: 'rtx-4070-super', length: 244, slots: 2, recommendedPSU: 650, connectors: '1x 16-pin' },
  'rtx-4070': { gpuId: 'rtx-4070', length: 244, slots: 2, recommendedPSU: 650, connectors: '1x 8-pin' },
  'rtx-4060-ti': { gpuId: 'rtx-4060-ti', length: 240, slots: 2, recommendedPSU: 550, connectors: '1x 8-pin' },
  'rtx-4060': { gpuId: 'rtx-4060', length: 240, slots: 2, recommendedPSU: 500, connectors: '1x 8-pin' },
  'rtx-3060': { gpuId: 'rtx-3060', length: 242, slots: 2, recommendedPSU: 550, connectors: '1x 8-pin' },
  'rtx-3050': { gpuId: 'rtx-3050', length: 229, slots: 2, recommendedPSU: 450, connectors: '1x 8-pin' },
  'rx-7900-xtx': { gpuId: 'rx-7900-xtx', length: 287, slots: 2.5, recommendedPSU: 800, connectors: '2x 8-pin' },
  'rx-9070-xt': { gpuId: 'rx-9070-xt', length: 276, slots: 2.5, recommendedPSU: 700, connectors: '2x 8-pin' },
  'rx-7900-xt': { gpuId: 'rx-7900-xt', length: 276, slots: 2.5, recommendedPSU: 750, connectors: '2x 8-pin' },
  'rx-9070': { gpuId: 'rx-9070', length: 267, slots: 2, recommendedPSU: 600, connectors: '2x 8-pin' },
  'rx-7900-gre': { gpuId: 'rx-7900-gre', length: 267, slots: 2.5, recommendedPSU: 650, connectors: '2x 8-pin' },
  'rx-7800-xt': { gpuId: 'rx-7800-xt', length: 267, slots: 2.5, recommendedPSU: 650, connectors: '2x 8-pin' },
  'rx-7700-xt': { gpuId: 'rx-7700-xt', length: 260, slots: 2.5, recommendedPSU: 600, connectors: '1x 8-pin' },
  'rx-7600-xt': { gpuId: 'rx-7600-xt', length: 240, slots: 2, recommendedPSU: 550, connectors: '1x 8-pin' },
  'rx-7600': { gpuId: 'rx-7600', length: 240, slots: 2, recommendedPSU: 500, connectors: '1x 8-pin' },
  'rx-6700-xt': { gpuId: 'rx-6700-xt', length: 267, slots: 2.5, recommendedPSU: 600, connectors: '1x 8-pin + 1x 6-pin' },
  'rx-6600': { gpuId: 'rx-6600', length: 230, slots: 2, recommendedPSU: 450, connectors: '1x 8-pin' },
  'arc-b580': { gpuId: 'arc-b580', length: 267, slots: 2, recommendedPSU: 550, connectors: '1x 8-pin' },
  'arc-a770': { gpuId: 'arc-a770', length: 267, slots: 2, recommendedPSU: 600, connectors: '2x 8-pin' },
  'arc-a750': { gpuId: 'arc-a750', length: 267, slots: 2, recommendedPSU: 550, connectors: '1x 8-pin + 1x 6-pin' },
};

export function getGPUPhysicalSpecs(gpuId: string): GPUPhysicalSpecs | undefined {
  return gpuPhysicalSpecs[gpuId];
}
